<script>
export default {
    props: {
        field: {
            type: Object,
            required: true,
        },
        value: {
            type: [String, Number, Boolean, Array, Object],
            default: null,
        },
    },
    computed: {
        fieldValue: {
            get() {
                return this.value;
            },
            set(field) {
                this.$emit('input', field);
            },
        },
        options() {
            return [
                {
                    text: 'Not set',
                    value: null,
                },
                ...this.field.options?.options ?? [],
            ];
        },
    },
};
</script>

<template>
    <b-form-radio-group
        v-model="fieldValue"
        :options="options"
        stacked
    />
</template>

<style
    scoped
    lang="scss"
>

</style>
